import vi from '@/internationalization/trans/chefs/vi/vi.json';
export default {
  trans: vi,
};
